import React from 'react';
import './index.scss';

class LoginDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

	loginByWechat = () => {}

	loginByQQ = () => {}

	render() {
	  return (
			<div className="loginDialog">
				<div className="dialog">
					<div className="close"></div>
					<div className="loginTitle">登录后才可签到</div>
					<div className="loginTip">选择你的登录方式</div>
					<div className="choose">
						<div className="item" onClick={() => this.loginByWechat()}>
							<div className="icon weixin"></div>
							微信
						</div>
						<div className="item" onClick={() => this.loginByQQ()}>
							<div className="icon qq"></div>
							QQ
						</div>
					</div>
				</div>
			</div>
	  );
	}
}

export default LoginDialog;
